import { NestedOption } from '~/core/shared/types/utility';

/**
 * A stored segment is unresolved when the select at its position does not offer it, which
 * covers a retired option and a path that continues past a leaf.
 */
export const isNestedSelectValueUnresolved = (
  selects: ReadonlyArray<readonly NestedOption[]>,
  segments: readonly string[],
): boolean =>
  segments.some(
    (segment, index) =>
      !selects[index]?.some((option) => option.value === segment),
  );
